import React from 'react';

export const IncompleteCell = ({value}: any) => {
  return (value ? (
    <img className="incomplete-data-icon" src={'./icons/close-blue.svg'} alt={`${value}`} title={`${value}`}/>
    ) : null)
}
